module.exports = __webpack_public_path__ + "static/recruit_home__reason-client-5d720e6c38608db63210fab9222767d2.png";